<script setup lang="ts">
import { NXGDSButton, NXGDSButtonVariants, NXGDSButtonSizes } from '@nsftx/seven-nxg-design-system'

import { useTicketCheckStore } from '@/stores/ticket-check/ticketCheckStore'

const ticketCheckStore = useTicketCheckStore()
const { showTicketCheckModal } = ticketCheckStore
</script>

<template>
  <div data-cy="ticketCheckButton">
    <NXGDSButton
      prepend-icon="betslip-b"
      :variant="NXGDSButtonVariants.secondary"
      :size="NXGDSButtonSizes.big"
      @click="showTicketCheckModal()"
    >
      <span data-cy="ticketCheckTitle">
        {{ $t('ticket_check') }}
      </span>
    </NXGDSButton>
  </div>
</template>
